import React from "react";
import { Tabs as Tabs$1 } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "../tooltip/Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import "../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../tooltip/AutoAdjustedComplexTooltip.styles.js";
import { MultiLineAutoAdjustedWidthTooltip } from "../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import { Tab } from "./Tab.js";
const useStyles = makeStyles()((theme) => ({
  tabs: {
    paddingLeft: theme.spacing(5),
    gap: theme.spacing(2)
  },
  root: {
    marginBottom: theme.spacing(2.5)
  }
}));
function Tabs({ value, onChange, tabs }) {
  const { classes } = useStyles();
  function handleChange(_, value2) {
    onChange(value2);
  }
  return /* @__PURE__ */ React.createElement(Tabs$1, { className: classes.root, classes: { flexContainer: classes.tabs }, value, onChange: handleChange }, tabs.map((tab) => /* @__PURE__ */ React.createElement(
    Tab,
    {
      value: tab.value,
      label: /* @__PURE__ */ React.createElement(MultiLineAutoAdjustedWidthTooltip, { linesCount: 1, breakByWords: false }, /* @__PURE__ */ React.createElement(LocalizedText, { label: tab.title })),
      key: tab.value
    }
  )));
}
export {
  Tabs
};
//# sourceMappingURL=Tabs.js.map
